import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { Loader2 } from "lucide-react";
import axios from "axios";

import API from "@/apiConfig";
import PublicPageView from "@/components/PublicPageView";

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/pages/${slug}`);
        setPage(res.data);
        if (res.data?.visibility === "hidden") {
          const meta = document.createElement("meta");
          meta.name = "robots";
          meta.content = "noindex";
          document.head.appendChild(meta);
        }
        if (res.data?.title) document.title = res.data.title;
      } catch {
        setError("Page not found");
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <Layout>
        <div className="min-h-[60vh] flex items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-gold" />
        </div>
      </Layout>
    );
  }

  if (error || !page) {
    return (
      <Layout>
        <div className="min-h-[60vh] flex items-center justify-center" data-testid="page-not-found">
          <div className="text-center">
            <h1 className="font-heading text-4xl text-navy mb-4">Page Not Found</h1>
            <p className="text-gray-500">The page you're looking for doesn't exist.</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div data-testid={`custom-page-${page.slug}`}>
        <PublicPageView page={page} />
      </div>
    </Layout>
  );
}
